"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushServerEvent = exports.bakeServerData = void 0;
const push_event_1 = require("../push-event");
const subscription_1 = require("../utilities/subscription");
const CLUSTER_URL = process.env.NODE_ENV === "development" ? "http://localhost:1338/" : "http://event-catcher/events";
const bakeServerData = (serverData) => {
    var _a, _b, _c, _d, _e;
    return {
        userId: (_b = (_a = serverData.user) === null || _a === void 0 ? void 0 : _a.id.toString()) !== null && _b !== void 0 ? _b : "-1",
        sessionId: serverData.sessionId,
        source: serverData.source,
        featureType: serverData.featureType,
        pathFrom: (_c = serverData.pathFrom) !== null && _c !== void 0 ? _c : "server",
        pathTo: (_d = serverData.pathTo) !== null && _d !== void 0 ? _d : "server",
        subscriptionType: (0, subscription_1.getSubscriptionType)((_e = serverData.user) === null || _e === void 0 ? void 0 : _e.stripeProducts)
    };
};
exports.bakeServerData = bakeServerData;
const pushServerEvent = (serverClientData) => {
    const data = (0, exports.bakeServerData)(serverClientData);
    (0, push_event_1.pushEvent)(CLUSTER_URL, data);
};
exports.pushServerEvent = pushServerEvent;
//# sourceMappingURL=index.js.map